import { render } from "./ItemListInnovacio.vue?vue&type=template&id=0b7fb180&scoped=true"
import script from "./ItemListInnovacio.vue?vue&type=script&lang=js"
export * from "./ItemListInnovacio.vue?vue&type=script&lang=js"

import "./ItemListInnovacio.vue?vue&type=style&index=0&id=0b7fb180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7fb180"]])

export default __exports__